import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { destinationsApi, destinationsKeys } from '@/features/destinations/api/destinations.api';
import { FALLBACK_LIVE_CITIES } from '@/features/destinations/constants';
import type { LiveCity } from '@/types';

const NO_CITIES: LiveCity[] = [];

/**
 * Cities the admin has put live on the home page, in display order. Falls
 * back to the launch cities if the request fails.
 */
export function useLiveCities() {
  const query = useQuery({
    queryKey: destinationsKeys.live(),
    queryFn: destinationsApi.listLive,
    staleTime: 10 * 60 * 1000,
  });

  const cities = query.data ?? (query.isError ? FALLBACK_LIVE_CITIES : NO_CITIES);

  const label = useMemo(() => cities.map((c) => c.name).join(', '), [cities]);

  return { cities, label, isLoading: query.isLoading };
}
